<template>
    <div class="p-3">
        <select-modal
            ref="selectempresa" 
            id="empresas"
            placeholder-button="Selecionar cooperadas" 

            modal-title="EMPRESA"
            :modal-fields="colunasModal"
            :fetch-method="metodoBusca"
            term-initial="tipo"
            :filter-options ="filterOptions"
            :fields="colunas"
            :values="dados"

            slot-image="logoDaEmpresa"
            :controles="projetoEditavel"  
            
            :esconderInserir="!permissao.u"
            

            @update="atualizarEmpresa"
        >
            <template #btn-remove="data">
                <div>
                    <b-button v-if="projetoEditavel && permissao.d && data.item.tipo == 'Cooperada' && data.item.empresaId != empresaSelecionada.id" variant="flat-danger" class="mr-2"  @click="excluirEmpresa(data.item)"><i class="fas fa-trash"></i></b-button>
                </div>
            </template>
        </select-modal>
    </div>
</template>
<script>

import SelectModal from "./modal";

import EmpresasService from "@/common/services/empresas/empresas.service";

//import cloneDeep from "lodash/cloneDeep";
import helpers from "@/common/utils/helpers";
import { START_LOADING, STOP_LOADING } from "@/store/Store";
import { AlertasMixin } from "@/common/mixins/AlertasMixin";
import ProjetoGestaoService from "@/common/services/projeto_gestao/projeto_gestao.service";

export default {
    name: "ProjetoGestaoEmpresas",
    emits: ["update"],
    mixins: [AlertasMixin],
    props: {
        projeto : {
            type: Object,
            required: true
        },
        projetoEditavel : {
            type : Boolean,
            default : false
        }
    },
    components: {
        SelectModal
    },
    data: () =>({
        filterOptions : [
            { key: "acoes", label: "Ações", tdClass: "acoes", },
            { key: "nomeFantasia", label: "Empresa", },
            { key: "tipo", label: "Tipo", },
            { key: "email", label: "E-mail", },  
            { key: "endereco.cidade", label: "Cidade", },  
            { key: "endereco.uf", label: "UF", },  
            { key: "actions", label: "Ações", tdClass: "acoes", },
        ],
        colunasModal : [
            { key: "acoes", label: "Ações", tdClass: "acoes", },
            { key: "logoDaEmpresa", label:""},
            { key: "nomeFantasia", label: "Empresa", },
            { key: "tipo", label: "Tipo", },
            { key: "email", label: "E-mail", },  
            { key: "endereco.cidade", label: "Cidade", },  
            { key: "endereco.uf", label: "UF", },  
            { key: "actions", label: "Ações", tdClass: "acoes", },
        ],
        colunas : [
            { key: "logoDaEmpresa", label:""},
            { key: "nomeFantasia", label: "Empresa", },
            { key: "tipo", label: "Tipo", },
            { key: "custosPrevistos", label: "Custos previstos(R$)",
                formatter: (v) => {
                    if(v != null) return helpers.formatarValor(v);
                }
            }, 
            { key: "custosRealizados", label: "Custos realizados(R$)",
                formatter: (v) => {
                    if(v != null) return helpers.formatarValor(v);
                }
            }, 
            {
                key : "remove",
                label : "Ações"
            }
        ],
        dados : []
    }),
    methods:{
        metodoBusca: function(){
            return new Promise((resolve, reject) => { 
                EmpresasService.buscarTipo('Proponente').then(res => {
                    let resultado = {
                        data : {
                            data : res.data.data.filter(
                                el => {
                                    return el.id != this.empresaSelecionada.id
                                    && this.dados.find(el2 => el2.empresaId == el.id) == undefined;
                                }
                            )
                        }
                    };
                    resolve(resultado);
                }).catch(err => {
                    reject(err);
                });
            });
        },
        atualizarEmpresa: function(empresa){
            
            if(empresa.selected){
                this.dados.push(empresa.item);
            }else{
                this.dados.pop(empresa.item);
            }

            let form = {
                id: this.projeto.id,
                projetoGestaoId: this.projeto.id,
                empresasId: [
                    empresa.item.id
                ]
            };

            this.$store.dispatch(START_LOADING);
            ProjetoGestaoService.salvarEmpresa(form).then(() => {
                this.toast("Empresas atualizadas com sucesso!",{
                    variant: "success",
                });
                this.buscarEmpresas().then(() => {
                    this.$refs['selectempresa'].recarregar();
                });
            }).catch(() => {
                this.toast("Ocorreu um erro ao atualizar as empresas",{
                    variant: "danger",
                });
            }).finally(() => {
                this.$store.dispatch(STOP_LOADING);
            });
        },
        excluirEmpresa : function(empresa){
            this.confirmar("Deseja remover essa empresa do projeto?").then(confirmado => {
                if(!confirmado) return;
                this.$store.dispatch(START_LOADING);
                ProjetoGestaoService.removerEmpresa(this.projeto.id, empresa.empresaId).then(() => {
                    this.alertaSucesso("Empresa removida com sucesso!");
                    this.buscarEmpresas();
                }).catch(() => {
                    this.alertaErro("Ocorreu um erro ao remover a empresa");
                }).finally(() => {
                    this.$store.dispatch(STOP_LOADING);
                });
            });
        },
        buscarEmpresas : function(){
            return new Promise((resolve) => {
                this.$store.dispatch(START_LOADING);
                ProjetoGestaoService.listarEmpresa(this.projeto.id).then(res => {
                    this.dados = res.data.data;
                    resolve();
                }).finally(() => {
                    this.$store.dispatch(STOP_LOADING);
                });
            });
        },
    },
    mounted(){
        this.buscarEmpresas();
    },
    computed: {
        empresaSelecionada() {
            return this.$store.state.app.selectedCompanyObj;
        },
        permissao() {
            return this.$store.getters['app/retornaPermissao']('ProjetosGestaoEmpresas');
        },
    }
}
</script>
<style>
    
</style>